import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "tdops_token";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

// 20s: long enough to survive a bad yard connection, short enough that a hung
// request fails while the user is still on the screen. Uploads override it with
// `timeout: 0` so a big video is never cut off.
const api = axios.create({ baseURL: API, timeout: 20000 });

// A separate client for public (no-login) endpoints: never attaches a token
// and never redirects to /login on 401.
export const publicApi = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    if (status === 401) {
      tokenStore.clear();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    } else if (status === 403 && detail === "MODULE_HIDDEN") {
      // The owner has turned off read access to this part. Send the user back
      // to a page they can always see, with a plain-Dutch note.
      toast.info("Dit onderdeel is niet zichtbaar voor jou.");
      if (window.location.pathname !== "/dashboard") {
        window.location.href = "/dashboard";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
